import { useEffect, useState } from "react";
import { useProfile } from "../../context/ProfileContext";

export const accessFlags = {
  LOADING: "loading",
  ACCEPTED: "accepted",
  DENIED: "denied",
};
export default function useAccess({ requiredGroups = [] } = {}) {
  const [accessStatus, setAccessStatus] = useState(accessFlags.LOADING);
  const { profile } = useProfile();

  useEffect(() => {
    if (!requiredGroups?.length) {
      if (accessStatus != accessFlags.ACCEPTED) {
        setAccessStatus(accessFlags.ACCEPTED);
      }
      return;
    }

    let hasAccess = true;
    const profileGroups = profile?.groups;
    if (profileGroups == undefined) {
      return;
    }
    for (let group of requiredGroups) {
      if (!profileGroups.includes(group)) {
        hasAccess = false;
        break;
      }
    }
    const newAccessStatus = hasAccess
      ? accessFlags.ACCEPTED
      : accessFlags.DENIED;

    if (newAccessStatus != accessStatus) {
      setAccessStatus(newAccessStatus);
    }
  }, [profile, requiredGroups, accessStatus]);

  return {
    status: accessStatus,
    hasAccess: accessStatus == accessFlags.ACCEPTED,
  };
}
